import { z } from 'zod'

import { horizontalAlignmentEnum } from '@/cms/helperTypes'

const displayTypeEnum = z.enum(['single', 'multiple'])

export const carouselSchema = z.object({
  _key: z.string().optional(),
  _type: z.literal('carousel'),
  name: z.string(),
  maxWidth: z.number().optional(),
  displayType: displayTypeEnum.optional(),
  infinite: z.boolean().optional(),
  variableWidth: z.boolean().optional(),
  arrowsHorizontalAlignment: horizontalAlignmentEnum.optional(),
  slides: z
    .array(
      z.object({
        _key: z.string(),
        content: z.array(z.unknown()),
      })
    )
    .optional(),
})

export type Carousel = z.infer<typeof carouselSchema>
